import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  selectedForUnShare: [] as string[],
  showShares: true
}

const opportunitiesSlice = createSlice({
  name: 'opportunities',
  initialState,
  reducers: {
    addOpportunityId(state, action: PayloadAction<string>) {
      state.selectedForUnShare.push(action.payload)
    },
    removeOpportunityId(state, action: PayloadAction<string>) {
      state.selectedForUnShare = state.selectedForUnShare.filter(id => id !== action.payload)
    },
    addAllOpportunityIds(state, action: PayloadAction<string[]>) {
      state.selectedForUnShare.push(...action.payload)
    },
    removeAllOpportunityIds(state, action: PayloadAction<string[]>) {
      state.selectedForUnShare = state.selectedForUnShare.filter(
        opportunityId => !action.payload.includes(opportunityId)
      )
    },
    setOpportunityIds(state, action: PayloadAction<string[]>) {
      state.selectedForUnShare = action.payload
    },
    setShowShares(state, action: PayloadAction<boolean>) {
      state.showShares = action.payload
    }
  }
})

export const {
  addOpportunityId,
  removeOpportunityId,
  addAllOpportunityIds,
  removeAllOpportunityIds,
  setOpportunityIds,
  setShowShares
} = opportunitiesSlice.actions
export default opportunitiesSlice.reducer
